import z from 'zod';
import { brandSelectSchema } from './doctor-data';


export const doctorEditDataSchema = z.object({
  displayName: z.string().optional(),
  fullName: z.string().optional(),
  webpage: z.string().url().optional(),
  specialty: z.string().optional(),
  email: z.string().email().optional(),
  phone: z.string().optional(),
  status: z.enum(['active', 'inactive', 'on-leave', 'retired']).optional(),
  brand: brandSelectSchema.optional(),
});

export type DoctorEditData = z.infer<typeof doctorEditDataSchema>;
